module.exports = __webpack_public_path__ + "img/domestic-1985-world-order.279e407a.jpg";